import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { TextViewerComponent } from '../../components/text-viewer/text-viewer.component';
import { TranscriptViewerComponent } from '../../components/transcript-viewer/transcript-viewer.component';
import { VideoPlayerComponent } from '../../components/video-player/video-player.component';
import { ApiService } from '../../services/api.service';
import { ExportExcelService } from '../../services/export-excel.service';
import { AppModule } from '../../utilities/app/app.module';
import { EllipsesPipe } from '../../utilities/pipes/ellipses.pipe';
import {
  DiarizationContent,
  NewVideoInfo,
  TargetVideoInfo,
  VideoInfo,
} from './model/view-content.model';

@Component({
  selector: 'app-view-content',
  standalone: true,
  templateUrl: './view-content.component.html',
  styleUrl: './view-content.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    VideoPlayerComponent,
    AppModule,
    TranscriptViewerComponent,
    TextViewerComponent,
    EllipsesPipe,
  ],
})
export class ViewContentComponent implements OnInit {
  video_content_data: VideoInfo = {} as VideoInfo;
  player_events = new BehaviorSubject<any>({});
  video_target_data: TargetVideoInfo = {} as TargetVideoInfo;
  target_events = new BehaviorSubject<any>({});

  sourceProducts: DiarizationContent[] = [];
  targetProducts: DiarizationContent[] = [];
  duplicateSourceProducts: DiarizationContent[] = [];

  video_player_options = {
    responsive: true,
    playbackRates: [ -2, -1, -0.5, 0.5, 1, 2 ],
    fluid: false,
    fill: true,
    aspectRatio: '3:4',
    controlBar: {
      skipButtons: {
        forward: 10,
        backward: 10,
      },
      loop: true,
      playToggle: {
        replay: false,
      },
      pictureInPictureToggle: true,
      nativeControlsForTouch: true,
    },
  };
  video_player_options1 = {
    responsive: true,
    playbackRates: [ -2, -1, -0.5, 0.5, 1, 2 ],
    fluid: false,
    fill: true,
    aspectRatio: '3:4',
    controlBar: {
      skipButtons: {
        forward: 10,
        backward: 10,
      },
      loop: true,
      playToggle: {
        replay: false,
      },
      pictureInPictureToggle: true,
      nativeControlsForTouch: true,
    },
  };

  player_reference: any;
  target_reference: any;
  current_diarization: any;
  frame_duration: any;
  isNewVideoCreated: boolean = true;
  showLoadedVideo: boolean = false;
  sourceId: string = '';
  newTargetDetails: NewVideoInfo[] = [];
  @HostListener('window:resize', [ '$event' ])

  onResize() {
  }

  newVideoBlob!: Blob;
  modifyTargetVideo: DiarizationContent[] = [];
  dataForExcel: any[] = [];

  constructor(
    private router: Router,
    public apiservice: ApiService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private excelService: ExportExcelService
  ) {
    const navigation: any = this.router.getCurrentNavigation()?.extras;
    if (navigation?.state) {
      let extras_state: any = navigation?.state;
      if (extras_state && extras_state[ 'playable_content' ]) {
        this.video_content_data = extras_state[ 'playable_content' ];
        this.video_content_data[ 'diarization_content' ] =
          this.video_content_data.db_data.outputs[ 'diarization_content' ];
        this.video_content_data[ 'transcript_content' ] =
          this.video_content_data.db_data.outputs[ 'transcript_content' ];
        const { _id }: any = this.video_content_data.db_data;
        this.sourceId = _id;
      } else {
        if (this.video_content_data == undefined || !this.video_content_data) {
          this.router.navigate([ '/home' ]);
        }
      }
    }
  }

  previous_values: any = {
    _previoius_transcript_div: { div: {}, style: {} },
    _previous_first_child: { div: {}, style: {} },
  };

  ngOnInit() {
    const final: any = this.video_content_data[ 'diarization_content' ].map(
      (result: DiarizationContent, i: number) => ({
        ...result,
        id: i,
        isCopied: false,
      })
    );
    this.sourceProducts = final;
    this.duplicateSourceProducts = [ ...final ];
    this.targetProducts = [];

    this.player_events?.subscribe((event: any) => {
      if (this.player_reference) {
        // this.player_reference.currentTime(event.time);
        let transcript_card =
          document.getElementsByClassName('p-picklist-source');
        let transcript_div = document.getElementById(
          'transcsripts_' + parseInt(event.time)
        );

        if (transcript_card && transcript_div) {
          if (
            this.previous_values[ '_previoius_transcript_div' ].div.style !=
            undefined &&
            this.previous_values[ '_previous_first_child' ].div.style != undefined
          ) {
            (
              this.previous_values[ '_previoius_transcript_div' ]
                .div as HTMLElement
            ).style.backgroundColor =
              this.previous_values[ '_previoius_transcript_div' ].style;
            (
              this.previous_values[ '_previous_first_child' ].div as HTMLElement
            ).style.color = this.previous_values[ '_previous_first_child' ].style;

            (
              this.previous_values[ '_previoius_transcript_div' ]
                .div as HTMLElement
            ).classList.remove('ishiglighted');
          }
          (
            this.previous_values[ '_previoius_transcript_div' ].div as HTMLElement
          ).classList?.add('ishiglighted');

          transcript_div.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          });
          let style = window.getComputedStyle(transcript_div);
          let backgroundColor = style.getPropertyValue('backgroundColor');

          this.previous_values[ '_previoius_transcript_div' ][ 'div' ] =
            transcript_div;
          this.previous_values[ '_previoius_transcript_div' ][ 'style' ] =
            backgroundColor;
          transcript_div.style.backgroundColor = 'var(--highlight-disabled)';

          let first_child = transcript_div.firstChild as HTMLElement;
          if (first_child) {
            let style = window.getComputedStyle(first_child);
            let backgroundColor = style.getPropertyValue('color');
            first_child.style.color = 'var(--text-color)';
            this.previous_values[ '_previous_first_child' ][ 'div' ] = first_child;
            this.previous_values[ '_previous_first_child' ][ 'style' ] =
              backgroundColor;
          }
        }
      }
    });
  }

  handle_player_events(event: any) {
    let current_time = event.time;
    let data: any = this.video_content_data[ 'diarization_content' ];

    for (
      let i = 0;
      i < this.video_content_data.diarization_content.length;
      i++
    ) {
      if (data[ i ].time <= current_time) {
        this.current_diarization = [ data[ i ] ];
      }
    }
    this.frame_duration = this.get_frames_time(current_time);
    this.player_events.next(event);
  }

  handle_click_on_transcript(event: number) {
    this.player_reference?.currentTime(event);
  }

  handle_player_reference(event: any) {
    this.player_reference = event;
  }

  get_frames_time(time_seconds: any) {
    var h = Math.floor(time_seconds / 3600)
      .toString()
      .padStart(2, '0');
    var m = Math.floor((time_seconds % 3600) / 60)
      .toString()
      .padStart(2, '0');
    var s = Math.floor((time_seconds % 3600) % 60)
      .toString()
      .padStart(2, '0');
    if (h === '00') {
      return m + ':' + s;
    }
    return h + ':' + m + ':' + s;
  }

  async onMoveTarget(event: any) {
    this.showLoadedVideo = true;
    this.isNewVideoCreated = true;
    this.newTargetDetails = [];

    for (let i = 0; i < event.items.length; i++) {
      await this.sourceProducts.splice(event.items[ i ].id, i, event.items[ i ]);
      const value: any = [];

      await this.targetProducts.forEach((data: any, i: number) => {
        value.push({ ...data, isCopied: false });
      });

      event.items[ i ].isCopied = await true;

      this.targetProducts = await [ ...value ];
      await this.getUniqueListBy(this.targetProducts, 'id');
    }
    if (this.targetProducts.length) {
      this.targetProducts.forEach((data: any, i: number) => {
        this.newTargetDetails.push({
          asset_id: this.sourceId,
          start_time: data.startTime,
          end_time: data.endTime,
          sequence: String(i + 1),
        });
      })
    }

    if (this.modifyTargetVideo.length !== this.targetProducts.length) {
      this.video_target_data = {
        show: true,
        name: this.video_content_data.name,
        url: '',
        corpora_name: this.video_content_data.name,
        diarization_content: [],
        transcript_content: [],
      };
    }
    let move_all_to_target = document.querySelector(
      '[aria-label="Move All to Target"]'
    );
    if (move_all_to_target) {
      if (this.targetProducts.length == this.sourceProducts.length) {
        move_all_to_target.setAttribute('disabled', 'true');
      } else {
        move_all_to_target.removeAttribute('disabled');
      }
    }
    await this.cdr.markForCheck();
  }

  getUniqueListBy(arr: any, key: string) {
    return [ ...new Map(arr.map((item: any) => [ item[ key ], item ])).values() ]
  }

  getValues(time: string, time1: string): string {
    return (Number(time) + Number(time1)).toString().replace('.', ':');
  }

  onTargetReorder(): void {
    this.showLoadedVideo = true;
    this.isNewVideoCreated = true;
    this.newTargetDetails = [];
    this.dataForExcel = [];
    this.targetProducts.forEach((data: any, i: number) => {
      this.newTargetDetails.push({
        asset_id: this.sourceId,
        start_time: data.startTime,
        end_time: data.endTime,
        sequence: String(i + 1),
      });
    });
    if (this.modifyTargetVideo.length !== this.targetProducts.length) {
      this.video_target_data = {
        show: true,
        name: this.video_content_data.name,
        url: '',
        corpora_name: this.video_content_data.name,
        diarization_content: [],
        transcript_content: [],
      };
    }
    this.cdr.markForCheck();
  }

  onLoadNewVideo(): void {
    this.modifyTargetVideo = [];
    this.dataForExcel = [];
    this.showLoadedVideo = true;
    if (this.dataForExcel.length == 0) {
      this.newTargetDetails.map(
        (result: any) =>
          this.dataForExcel.push({
            id: result.sequence,
            videoName: this.video_content_data.name,
            startTime: this.get_frames_time(result.start_time),
            endTime: this.get_frames_time(result.end_time),
            sourceDuration: this.get_frames_time(
              result.end_time - result.start_time
            ),
            recordIn: this.dataForExcel.length == 0 ? this.get_frames_time('00') : this.dataForExcel[ this.dataForExcel.length - 1 ].recordOut,
            recordOut: this.dataForExcel.length == 0 ? this.get_frames_time(result.end_time - result.start_time) : this.getValues(
              this.dataForExcel[ this.dataForExcel.length - 1 ].recordOut.replace(
                /:\s*/g,
                '.'
              ),
              this.get_frames_time(result.end_time - result.start_time).replace(
                /:\s*/g,
                '.'
              )
            ),
          })
      );
    }
    this.apiservice
      .get_merged_video(this.newTargetDetails)
      .subscribe((response: Blob) => {
        this.showLoadedVideo = false;
        this.isNewVideoCreated = false;
        this.newVideoBlob = response;
        const newVideo: any = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(response)
        );
        this.video_target_data = {
          show: true,
          name: this.video_content_data.name,
          url: newVideo?.changingThisBreaksApplicationSecurity,
          corpora_name: this.video_content_data.name,
          diarization_content: this.targetProducts,
          transcript_content: [],
        };
        this.modifyTargetVideo.length = this.targetProducts.length;
      });
  }

  async onMoveToSource(event: any) {
    const index = this.sourceProducts.findIndex((result: any) => result.id === event.items[ 0 ].id);
    let isFalse = await this.sourceProducts.every(
      (result: any) => result.isCopied == false
    );
    if (isFalse) {
      this.sourceProducts = await [ ...this.duplicateSourceProducts ];
    }
    if (this.sourceProducts[ index ].id === event.items[ 0 ].id) {
      this.sourceProducts.splice(index, 1);
      this.sourceProducts[ event.items[ 0 ].id ].isCopied = false;
    }
    let uniqueChars = this.sourceProducts.filter((element, index) => {
      return this.sourceProducts.indexOf(element) === index;
    });

    this.sourceProducts = [ ...new Set(uniqueChars) ];
    this.cdr.markForCheck();
  }

  async onMoveAllToTarget(event: any) {
    let src: any = [];
    let target: any = [];

    event.items.forEach((element: any) => {
      src.push({ ...element, isCopied: true });
    });

    event.items.forEach((element: any) => {
      target.push({ ...element, isCopied: false });
    });

    this.targetProducts = [];
    this.sourceProducts = [];
    this.sourceProducts = src;
    this.targetProducts = target;
    let move_all_to_target = document.querySelector(
      '[aria-label="Move All to Target"]'
    );

    if (move_all_to_target) {
      move_all_to_target.setAttribute('disabled', 'true');
    }
    this.newTargetDetails = [];
    this.targetProducts.forEach((data: any, i: number) => {
      this.newTargetDetails.push({
        asset_id: this.sourceId,
        start_time: data.startTime,
        end_time: data.endTime,
        sequence: String(i + 1),
      });
    });
    this.isNewVideoCreated = true;
    this.showLoadedVideo = true;
    await this.cdr.markForCheck();
  }

  onSourceSelect(): void {
    //this.handle_click_on_transcript(event);
  }

  handle_target_events(event: any) {
    let current_time = event.time;
    let data: any = this.video_target_data[ 'diarization_content' ];

    for (
      let i = 0;
      i < this.video_target_data.diarization_content.length;
      i++
    ) {
      if (data[ i ].time <= current_time) {
        this.current_diarization = [ data[ i ] ];
      }
    }
    this.frame_duration = this.get_frames_time(current_time);
    this.target_events.next(event);
  }

  handle_target_reference(event: any) {
    this.target_reference = event;
  }

  handle_click_on_output_transcript(event: number) {
    this.target_reference?.currentTime(event);
  }

  handle_output_target_reference(event: any) {
    this.target_reference = event;
  }

  onExportCSV(): void {
    this.dataForExcel.map((result: any) => {
      result.recordIn = Number(result.recordIn.replace(':', '.')).toFixed(2);
      result.recordOut = Number(result.recordOut.replace(':', '.')).toFixed(2);
      if (result.recordIn) {
        let recordIn = result.recordIn.split('.');
        if (recordIn[ 0 ] < 10) {
          recordIn = '0' + recordIn[ 0 ] + ':' + recordIn[ 1 ];
        } else {
          recordIn = recordIn[ 0 ] + ':' + recordIn[ 1 ];
        }
        result.recordIn = recordIn;
      }
      if (result.recordOut) {
        let recordOut = result.recordOut.split('.');
        if (recordOut[ 0 ] < 10) {
          recordOut = '0' + recordOut[ 0 ] + ':' + recordOut[ 1 ];
        } else {
          recordOut = recordOut[ 0 ] + ':' + recordOut[ 1 ];
        }
        result.recordOut = recordOut;
      }
    })
    let reportData = {
      title: this.video_target_data.name,
      data: this.dataForExcel,
      headers: [
        'S.no',
        'Reel Name',
        'Source In',
        'Source Out',
        'Source Duration',
        'Record In',
        'Record Out',
      ],
    };
    this.excelService.exportExcel(reportData);
  }

  onDownloadNewVideo(): void {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(this.newVideoBlob);
    a.href = objectUrl;
    a.download = `${this.video_content_data.name}.mp4`;
    a.click();
    URL.revokeObjectURL(objectUrl);
  }

  onDeleteTargetItem(target: any): void {
    const index = this.targetProducts.findIndex(
      (result: any) => result.id === target.id
    );
    this.targetProducts.splice(index, 1);
    this.newTargetDetails.splice(index, 1);
    if (this.sourceProducts[ target.id ].isCopied)
      this.sourceProducts[ target.id ].isCopied = false;
    this.isNewVideoCreated = true;
    if (this.targetProducts.length) {
      this.showLoadedVideo = true;
      this.video_target_data = {
        show: true,
        name: this.video_content_data.name,
        url: '',
        corpora_name: this.video_content_data.name,
        diarization_content: this.targetProducts,
        transcript_content: [],
      };
      this.newTargetDetails = [];
      this.targetProducts.forEach((data: any, i: number) => {
        this.newTargetDetails.push({
          asset_id: this.sourceId,
          start_time: data.startTime,
          end_time: data.endTime,
          sequence: String(i + 1),
        });
      })
    } else {
      this.showLoadedVideo = false;
      this.isNewVideoCreated = true;
    }
  }

  async onSourceReorder(event: any) {
    const duplicate = [ ...this.sourceProducts ];
    let isTrue = await this.sourceProducts.every(
      (result: any) => result.isCopied == true
    );
    if (isTrue) {
      this.sourceProducts = await [ ...this.duplicateSourceProducts ];
    } else {
      if (!this.sourceProducts[ event.items[ 0 ].id ].isCopied) {
        //this.sourceProducts[event.items[0].id] = await event.items[0];
        //this.sourceProducts = await [...this.sourceProducts];
        this.sourceProducts = await [ ...this.duplicateSourceProducts ];
        this.cdr.markForCheck();
      } else {
        await this.sourceProducts.splice(event.items[ 0 ].id, 1);
        let resultArray = duplicate.sort((first, second) =>
          first.id > second.id ? 1 : -1
        );
        this.sourceProducts = [ ...resultArray ];
        this.cdr.markForCheck();
      }
    }
  }

  deleteTargetItems(): void {
    this.targetProducts = [];
    this.sourceProducts.map((result: any) => (result.isCopied = false));
    this.showLoadedVideo = false;
    this.isNewVideoCreated = true;
    this.video_target_data = {
      show: true,
      name: this.video_content_data.name,
      url: '',
      corpora_name: this.video_content_data.name,
      diarization_content: this.targetProducts,
      transcript_content: [],
    };
    let move_all_to_target = document.querySelector(
      '[aria-label="Move All to Target"]'
    );

    if (move_all_to_target) {
      move_all_to_target.setAttribute('disabled', 'false');
    }
    this.cdr.markForCheck();
  }

  disableDBLClick(event: any) {
    event.stopPropagation(); return false;
  }

  onTargetSelect(event: any) {
    return false;
  }

  ngOnDestroy() {
    this.video_content_data = {
      show: false,
      name: '',
      url: '',
      corpora_name: '',
      diarization_content: [],
      transcript_content: [],
      db_data: {
        diarization_content: [],
        id: '',
        outputs: {
          diarization_content: [],
          transcript_content: [],
        },
      },
    };
  }
}
